import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";
import { RolePermission } from "./addRole";

export interface DeleteRolePayload {
  role: string;
}

export interface DeleteRoleResponse {
  success: boolean;
  message: string;
  data: RolePermission;
}

const deleteRole = async (
  payload: DeleteRolePayload
): Promise<DeleteRoleResponse> => {
  const { role } = payload;
  const { data } = await customAxios.delete<DeleteRoleResponse>(
    `/permissions/roles/${role}`
  );
  return data;
};

export const useDeleteRole = () => {
  const queryClient = useQueryClient();

  return useMutation<DeleteRoleResponse, AxiosError, DeleteRolePayload>(
    {
      mutationFn: deleteRole,
      onSuccess: async (data) => {
        showNotification({
          title: "Success",
          message: data.message,
          color: "green",
        });
        await queryClient.invalidateQueries(["permissions-roles"]);
      },
      onError: (error) =>
        showNotification({
          title: "Error",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to delete role",
          color: "red",
        }),
    }
  );
};
